
import { actions } from '../constants/userHome';
import * as types from '../../models/action/userHome';
import { SecurityContextType } from '../../models/enums/securityContextType';
import { Log } from 'ng2-logger';
import { IDashboardActivityItem } from '../../models/components/dashboard-activities';
import { ActivityType } from '../../models/components/lesson-upcoming-activity';
import { ICourseFilters } from '../../models/components/user-home_my_courses';

const _logger = Log.create('userHome.ts');
// #region User Home Calendar Actions
export function getUserCalendarActivities(contextType: SecurityContextType, contextId: string | Array<string>, filter: types.IFilter | null, startDate: Date | null, endDate: Date | null, skip: number, take?: number, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: any, isNowThenPast?: boolean): types.IUserCalendarActivitiesAction {
    return {
        contextType,
        contextId,
        filter,
        endDate,
        startDate,
        take,
        skip,
        timestamp: Date.now(),
        type: actions.GET_USER_HOME_CALENDAR_ACTIVITIES,
        spinnerId,
        spinnerType,
        callback,
        isNowThenPast
    };
}

export function setUserCalendarActivities(
    userHomeCalendarActivities: Array<IDashboardActivityItem> | null,
    userHomeCalendarIsLoading: boolean,
    take: number,
    skip: number,
    spinnerId?: string,
    spinnerType?: 'set' | 'get',
    isNowThenPast?: boolean
): types.IUserCalendarActivitiesSetAction {
    return {
        userHomeCalendarActivities,
        userHomeCalendarIsLoading,
        timestamp: Date.now(),
        type: actions.SET_USER_HOME_CALENDAR_ACTIVITIES,
        spinnerId,
        spinnerType,
        skip,
        take,
        isNowThenPast
    };
}
// #endregion User Home Calendar Actions end

// #region User Home My Courses Actions
export function getUserHomeMyCourses(isTeacher: boolean, spinnerId?: string, spinnerType?: 'get' | 'set', searchText?: string,
 filters?: ICourseFilters,callback?: (value: boolean) => void): types.IUserHomeMyCoursesAction {
    return {
        isTeacher,
        searchText,
        filters,
        callback,
        timestamp: Date.now(),
        type: actions.GET_USER_HOME_MY_COURSES,
        spinnerId,
        spinnerType
        
    };
}

export function getUserHomeUpcomingActivities(ClassId: string, CourseId: string, Skip: number, Take: number, Hour: number, spinnerId?: string, spinnerType?: 'get' | 'set', searchText?: string): types.IUserHomeUpcomingActivitiesAction {
    return {
        ClassId,
        CourseId,
        Skip,
        Take,
        Hour,
        timestamp: Date.now(),
        type: actions.GET_USER_UPCOMING_ACTIVITIES,
        spinnerId,
        spinnerType
    };
}
export function clearUserHomeUpcomingActivities() {
    return {
        timestamp: Date.now(),
        type: actions.CLEAR_USER_UPCOMING_ACTIVITIES
    };
}

export function setUserHomeMyCourses(
    userHomeMyCourses: Array<{
        activeStatus: number | null,
        endDate: Date | null,
        logoUrl: string | null,
        name: string | null,
        progress: number,
        startDate: Date | null,
        Teachers: string | null,
        classId: string | null,
        courseId: string | null,
        isNotifications: number | null,
        programName: string | null,
        classCount: number | null,
        starred:boolean,
        courseStartDate: Date | null,
        courseEndDate: Date | null
    }> | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.IUserHomeMyCoursesSetAction {
    return {
        userHomeMyCourses,
        timestamp: Date.now(),
        type: actions.SET_USER_HOME_MY_COURSES,
        spinnerId,
        spinnerType
    };
}

export function setUserHomeUpcomingActivities(
    upcomingActivities?: {
        ActivityType: ActivityType | null,
        Deadline: Date | null,
    },
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.IUserHomeUpcomingActivitiesSetAction {
    return {
        upcomingActivities,
        timestamp: Date.now(),
        type: actions.SET_USER_UPCOMING_ACTIVITIES,
        spinnerId,
        spinnerType
    };
}

export function setSearchFilters(
    searchfilters?: ICourseFilters | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.ISetSearchFiltersAction {
    return {
        searchfilters,
        timestamp: Date.now(),
        type: actions.SET_SEARCH_FILTERS,
        spinnerId,
        spinnerType
    };
}

// #endregion User Home My Courses Actions end
